export const convertIntoValueAndPercentage = (arrayOfData: { data: number; color: string }[]) => {
  const totalData = arrayOfData.reduce((acc: number, currentData: { data: number; color: string }) => {
    return acc + currentData.data;
  }, 0);
  const intl = Intl.NumberFormat('en-US', {
    notation: 'compact',
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  });
  const percentage = arrayOfData?.map((item) => {
    const dataAsPercentage = (item.data * 100) / totalData;
    const percentageAsInteger = intl.format(dataAsPercentage);
    return {
      ...item,
      data: item.data,
      formattedData: item.data ? `${item.data} (${percentageAsInteger}%)` : '0',
    };
  });

  return percentage;
};

export const calcTotalHouseholdIncome = (applicationData: {
  householdIncome: any[];
  application: { incomeSources: Record<string, number> };
}) => {
  const { application, householdIncome = [] } = applicationData;

  const totalSubmmiterIncome = Object.values(application?.incomeSources || {}).reduce((acc, source) => acc + source, 0);

  const totalHouseholdIncome = householdIncome.reduce((acc, curr: any) => {
    const wages = curr?.wages !== '' ? Number(curr?.wages) : 0;
    const pensions = curr?.pensions !== '' ? Number(curr?.pensions) : 0;
    const publicAssistance = curr?.publicAssistance !== '' ? Number(curr?.publicAssistance) : 0;
    const otherIncome = curr?.otherIncome !== '' ? Number(curr?.otherIncome) : 0;
    return acc + wages + pensions + publicAssistance + otherIncome;
  }, 0);

  return totalSubmmiterIncome + totalHouseholdIncome;
};

export const getAverageHouseholdIncome = (applicationsList: any[], widgetsData?: { totalHouseholdIncome: number }) => {
  if (!widgetsData || !widgetsData.totalHouseholdIncome || !applicationsList) return 0;

  return Math.round(widgetsData.totalHouseholdIncome / applicationsList.length);
};

export const isYes = (value: string) => ['yes', 'Y'].includes(value);
export const isNo = (value: string) => ['no', 'N'].includes(value);
